import React from "react";
import { useTranslation } from "react-i18next";
import { ListGroup } from "components/bootstrap";
import ControlledTableListHeader from "./ControlledTableListHeader";
import ControlledTableListItem from "./ControlledTableListItem";
const ControlledTableList = ({ children }) => {
  const { t } = useTranslation("common");
  let effectiveChildren;
  if (children.length === 0) {
    effectiveChildren = /* @__PURE__ */ React.createElement(ControlledTableListItem, null, t("empty.no_items"));
  } else {
    effectiveChildren = children;
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ListGroup, null, effectiveChildren));
};
ControlledTableList.Header = ControlledTableListHeader;
ControlledTableList.Item = ControlledTableListItem;
export default ControlledTableList;
